// extracted by mini-css-extract-plugin
module.exports = {"content":"contact_content__czCQS","form":"contact_form__0pV_U","submitButton":"contact_submitButton__Mvk7n"};